module.exports = __webpack_public_path__ + "static/media/perfect-gold_00012.984114cd.png";